var Codec = require('io/codec');
var SystemPrincipal = require('features/security').SystemPrincipal;

var serialiser = {
    read : function(input) {
        var name = Codec.readString(input);
        var roles = Codec.readCollection(input, Codec.readString);

        return new SystemPrincipal(name, roles);
    },
    write : function(output, principal) {
        Codec.writeString(output, principal.name);
        Codec.writeCollection(output, principal.roles, Codec.writeString);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/authentication/system-principal-serialiser.js
// module id = 475
// module chunks = 1